import { Component, computed, effect, inject, input, linkedSignal } from '@angular/core';
import {
  ConsumptionFilter,
  ConsumptionStore,
  getInitialFilter,
} from '../../../analysis/stores/consumption.store';
import { AnalysisConsumptionGraphCard } from '../../../analysis/components/analysis-consumption-graph-card/analysis-consumption-graph-card';
import { EnergyInterfaceDetailsPage } from '../energy-interface-details-page/energy-interface-details-page';
import { AnalysisConsumptionDetailsKpiCard } from '../../../analysis/components/analysis-consumption-details-kpi-card/analysis-consumption-details-kpi-card';
import { AnalysisConsumptionDetailsPeakloadKpiCard } from '../../../analysis/components/analysis-consumption-details-peakload-kpi-card/analysis-consumption-details-peakload-kpi-card';
import { Button, SwitchBar, SwitchBarOption } from 'excellence-ui';
import { NgIcon } from '@ng-icons/core';
import { form, FormField } from '@angular/forms/signals';
import { RouterLink } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';
import { HasRoleDirective } from '../../../../shared/directives/has-role';

@Component({
  selector: 'app-energy-interface-details-consumption-page',
  imports: [
    AnalysisConsumptionGraphCard,
    AnalysisConsumptionDetailsKpiCard,
    AnalysisConsumptionDetailsPeakloadKpiCard,
    Button,
    NgIcon,
    SwitchBar,
    SwitchBarOption,
    FormField,
    RouterLink,
    TranslocoPipe,
    HasRoleDirective,
  ],
  templateUrl: './energy-interface-details-consumption-page.html',
})
export class EnergyInterfaceDetailsConsumptionPage {
  private consumptionStore = inject(ConsumptionStore);
  private detailsPage = inject(EnergyInterfaceDetailsPage);

  organizationId = input.required<string>();

  protected energyInterfaceState = this.detailsPage.state;

  protected filter = linkedSignal<ConsumptionFilter | null>(() => {
    const state = this.energyInterfaceState();

    if (!state?.data) {
      return null;
    }

    const energyInterfaceID = state?.id ?? '';
    const utilityType = state?.data?.utilityType === 'GAS' ? 'GAS' : 'ELECTRICITY';
    const direction = state?.data?.flowDirection === 'FEED_IN' ? 'PRODUCTION' : 'CONSUMPTION';

    const filter = getInitialFilter();
    return {
      ...filter,
      data: {
        ...filter.data,
        energyInterfaceID,
        utilityType,
        direction,
      },
    };
  });

  private model = linkedSignal(() => this.filter() ?? getInitialFilter());
  protected form = form(this.model);

  protected data = computed(() => {
    const filter = this.filter();
    if (!filter) {
      return null;
    }
    return this.consumptionStore.get(filter);
  });

  constructor() {
    effect(() => {
      const filter = this.filter();
      if (filter === null) {
        return;
      }
      if (!this.consumptionStore.get(filter)) {
        this.consumptionStore.load(filter);
      }
    });
  }

  protected onChangeDate(date: Date) {
    this.filter.update((f) =>
      f === null
        ? null
        : {
            ...f,
            date,
          },
    );
  }

  protected onChangeGranularity(granularity: ConsumptionFilter['granularity']) {
    this.filter.update((f) =>
      f === null
        ? null
        : {
            ...f,
            granularity,
          },
    );
  }

  protected onChangeView(view: unknown) {
    this.filter.update((f) =>
      f === null
        ? null
        : {
            ...f,
            view: view as ConsumptionFilter['view'],
          },
    );
  }

  protected onClickReload() {
    const filter = this.filter();
    if (!filter) {
      return;
    }
    this.consumptionStore.load(filter);
  }
}
